import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import {
    ApplyButton,
    MekiHero,
    MekiOffersCta,
    MekiQuote,
    MekiSectionHeading,
    MekiWorkOverview,
    Paragraphs,
} from 'components/MekiPageSections';
import { mekiRolePages } from 'data/mekiPages';

export default function MekiRolePage() {
    const [searchParams] = useSearchParams();
    const key = searchParams.get('key');
    const role = mekiRolePages[key];

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [key]);

    if (!role) return <Navigate to='/meki' replace />;

    return (
        <main className='w-full bg-white/20'>
            <MekiHero
                title={role.title}
                lead={role.lead}
                image={role.heroImage}
                contentId='munkakor-reszletek'
                showApply
            />

            <section id='munkakor-reszletek' className='relative z-10 -mt-6 scroll-mt-20 bg-stone-50 px-site pb-16 pt-28 sm:pb-24 sm:pt-32'>
                <div className='mx-auto flex w-full max-w-boxed flex-col gap-8 sm:gap-10'>
                    <MekiSectionHeading>{role.heading}</MekiSectionHeading>
                    <Paragraphs items={[role.intro]} />

                    <div className='grid grid-cols-1 items-stretch gap-6 lg:grid-cols-2'>
                        <figure className='min-h-80 overflow-hidden rounded-3xl bg-neutral-200 shadow-2xl sm:min-h-96'>
                            <img src={role.featureImage} alt='' className='size-full object-cover' />
                        </figure>
                        <MekiQuote paragraphs={role.quote} name={role.quoteName} />
                    </div>

                    <div className='flex flex-col items-center rounded-3xl bg-white p-6 text-center shadow-xl shadow-red-900/5 sm:p-10 lg:p-12'>
                        <Paragraphs items={role.body} className='max-w-5xl items-center' />
                        <p className='mt-7 font-display text-xl font-black text-red-700 sm:text-2xl lg:text-3xl'>{role.closing}</p>
                        <ApplyButton className='mt-7' />
                    </div>
                </div>
            </section>

            <MekiOffersCta />
            <MekiWorkOverview excludeKey={key} />
        </main>
    );
}
